import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AmazonItems } from 'src/app/interfaces/amazondata';

@Component({
    selector: 'new-product-amazon',
    templateUrl: './new-product-amazon.component.html',
    styleUrls: ['./new-product-amazon.component.scss'],
    standalone: false
})


export class NewProductAmazonComponent implements OnInit {


  hideImage = false;
  textInformacoes = "Mais";
  constructor() { }
  @Output() select:EventEmitter<AmazonItems> = new EventEmitter(); 
  @Input() amazondata:AmazonItems;
  ngOnInit(): void {
      
  }
  ngAfterViewInit(){
    
  }
  selectData(){
    this.select.emit(this.amazondata);
  }

  clickInfo(){
    this.hideImage=!this.hideImage; 
    if ( !this.hideImage ){
       this.textInformacoes='Mais';
    }else{
      this.textInformacoes= 'Menos'; 
    }
  }
}